export const INSERT_BUTTON_BUTTON = 'insert-button-button';
export const BUTTON_LINK_SETTINGS_BUTTON = 'button-link-settings-button';

export const ROOT = 'button-viewer';

export const SETTINGS_MODAL = 'button-settings-modal';
export const SETTINGS_TABS = 'settings-tabs';
export const SETTINGS_GENERAL_TAB = 'settings-general-tab';
export const SETTINGS_DESIGN_TAB = 'settings-design-tab';

export const DESIGN_SETTINGS_BORDER_WIDTH_INPUT = 'design-settings-border-width-input';
export const DESIGN_SETTINGS_BORDER_WIDTH_SLIDER = 'design-settings-border-width-slider';
export const DESIGN_SETTINGS_CORNER_RADIUS_INPUT = 'design-settings-corner-radius-input';
export const DESIGN_SETTINGS_CORNER_RADIUS_SLIDER = 'design-settings-corner-radius-slider';
export const DESIGN_SETTINGS_TEXT_COLOR_PREDEFINED_SWATCH =
  'design-settings-text-color-predefined-swatch';
export const DESIGN_SETTINGS_BORDER_COLOR_PREDEFINED_SWATCH =
  'design-settings-border-color-predefined-swatch';
export const DESIGN_SETTINGS_BACKGROUND_COLOR_PREDEFINED_SWATCH =
  'design-settings-background-color-predefined-swatch';
export const DESIGN_SETTINGS_TEXT_COLOR_SWATCHES = 'design-settings-text-color-swatches';
export const DESIGN_SETTINGS_BORDER_COLOR_SWATCHES = 'design-settings-border-color-swatches';
export const DESIGN_SETTINGS_BACKGROUND_COLOR_SWATCHES =
  'design-settings-background-color-swatches';
export const DESIGN_SETTINGS_TEXT_COLOR_MORE_BUTTON = 'design-settings-text-color-more-button';
export const DESIGN_SETTINGS_BORDER_COLOR_MORE_BUTTON = 'design-settings-border-color-more-button';
export const DESIGN_SETTINGS_BACKGROUND_COLOR_MORE_BUTTON =
  'design-settings-background-color-more-button';

export const GENERAL_SETTINGS_BUTTON_TEXT_INPUT = 'general-settings-button-text-input';
